package gr.tech.site.models

data class NextEvent(
    val name: String,
    val date: String,               // ISO YYYY-MM-DD start date
    val endDate: String = "",       // ISO YYYY-MM-DD end date; empty if single-day
    val description: String,
    val venueName: String,
    val city: String,
    val state: String = "",         // empty for virtual events
    val category: String,           // "Trade Show", "Webinar", "Conference", "Workshop"
    val url: String = "",           // external link to event details/registration
    val imageUrl: String = ""       // optional header image
)
